package de.oevbs.kunde.kundenportal2.model.services.mydata

import de.oevbs.businesspartner.bpcrmservice2.bankaccount.model.BankAccount
import de.oevbs.kunde.kundenportal2.ServiceInfo
import de.oevbs.sfa.communication.ClientDefinition
import de.oevbs.sfa.communication.ClientResponse

abstract class MyDataClientDefinition(origin: String) : ClientDefinition(ServiceInfo, origin, ServiceInfo.name) {

    override val requestTimeoutMillis: Long = 30000L

    /**
     * Läd die Kontaktinformationen des eingeloggten Users/Partners.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun initContactInfo(): ClientResponse<ContactInformation> =
        get("/mydata/initcontactinfo")


    /**
     * Läd die Bankdaten des eingeloggten Users/Partners.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun initBankData(): ClientResponse<List<BankAccount>> =
        get("/mydata/initbankdata")

    /**
     * Speichert die neuen Kontaktdaten des eingeloggten Users/Partners, die in [contactInfo] übergeben wurden.
     *
     * Adressdaten-Prüfung:
     *
     * Wenn [contactInfo.forceUseUserInputAddress] false ist, wird die Adresse zunächst mit dem AddressCheck des BPCRM
     * geprüft. Es wird dann bei Abweichung gegebenenfalls ein Adressvorschlag im Rückgabemodell zurückgegeben. Der User
     * wählt nun im UI eine der beiden Adressen aus. Wenn beim erneuten Senden der Daten
     * [contactInfo.forceUseUserInputAddress] true ist, wird die ursprünglich vom User eingegebene Adresse gespeichert,
     * sonst der Adressvorschlag.
     *
     * Wenn die Mailadresse angepasst wurde, wird sie sowohl im Partner als auch im Kundenportal-Account angepasst.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun saveContactInfo(contactInfo: ContactInformation): ClientResponse<ContactInformation> =
        post("/mydata/savemydata", contactInfo)

    /**
     * Überschreibt das Bankkonto mit der Id [bankAccount.id] des eingeloggten Users/Partners mit den Kontodaten
     * in [bankAccount].
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun saveBankData(bankAccount: BankAccount): ClientResponse<Unit> =
        post("/mydata/savebankdata", bankAccount)

}